<template>
    <footer class="d-flex justify-content-center align-items-center">
        <BContainer>
            <BRow>
                <BCol lg="12">
                    <div class="text-center">
                        <p class="mb-0 text-muted">
                            &copy; {{ new Date().getFullYear() }} {{ $appConfig.nomeSito }}. {{ $t("t-copyright") }}
                        </p>
                    </div>
                </BCol>
            </BRow>
        </BContainer>
    </footer>
</template>